import React from 'react';
import PropTypes from 'prop-types';
import {useSelector} from 'react-redux';
import {displayDistanceFromMetres} from 'Utils/unitOfMeasure';
import FeaturePropType from 'Utils/propTypes/FeaturePropType';
import turfDistance from '@turf/distance';
import {getCenterPoint} from 'Utils/data/mapDataUtils';
import {prependDigitalAssetsUrl} from 'Utils/prependDigitalAssetsUrl';
import {getAncestorsDisplayText} from 'Utils/locationUtils';
import InfoCard from 'Components/common/InfoCard/InfoCard';

const TenantCard = ({tenantFeature, selectTenantFeature, currentKioskFeature}) => {
    const showTenant = () => {
        selectTenantFeature(tenantFeature);
    };

    const imdfCategoryName = tenantFeature.properties.tenant.imdfCategory?.name;

    const ancestors = tenantFeature.properties?.ancestors || [];

    const address = getAncestorsDisplayText([tenantFeature.properties.locationName, ...ancestors]);

    const unitOfMeasure = useSelector(state => state.pageState.layout.config.settings.units);
    const tenantFeatureCoords = getCenterPoint(tenantFeature);
    const distanceToFeature = currentKioskFeature?.geometry?.coordinates
        ? turfDistance(currentKioskFeature?.geometry?.coordinates, tenantFeatureCoords, {
              unit: 'kilometers',
          }) * 1000
        : false;
    const distance =
        distanceToFeature && displayDistanceFromMetres(unitOfMeasure, distanceToFeature);

    const tenantImageUrl = tenantFeature.properties.tenant?.imageUrls?.thumb;
    const tenantIconUrl = tenantFeature?.tenant?.iconUrls?.url;

    return (
        <InfoCard
            bottomText={address}
            distance={distance}
            iconUrl={tenantIconUrl ? prependDigitalAssetsUrl(tenantIconUrl) : undefined}
            imageUrl={tenantImageUrl ? prependDigitalAssetsUrl(tenantImageUrl) : undefined}
            onClick={showTenant}
            title={tenantFeature.properties.tenant.name}
            topText={imdfCategoryName}
        />
    );
};

TenantCard.propTypes = {
    tenantFeature: PropTypes.object.isRequired,
    selectTenantFeature: PropTypes.func.isRequired,
    currentKioskFeature: FeaturePropType,
};

export default TenantCard;
